/**
 * @fileoverview Header Component
 * 
 * This file contains the Header component used throughout the Heidrick & Struggles
 * Leader Profile application. It displays either a title or a logo image,
 * followed by the "Leader Portal" text.
 * 
 * The component conditionally renders either:
 * 1. A text title when headerLogo is not provided, or
 * 2. A logo image when headerLogo is provided
 */

import React from "react";

/**
 * Header Component
 * 
 * Renders the application header with either a text title or a logo image,
 * followed by the "Leader Portal" text. This provides consistent branding
 * across the application while allowing for client-specific customization.
 * 
 * @param {Object} props - Component props
 * @param {string} [props.title] - Optional text title to display when no logo is provided
 * @param {string} [props.headerLogo] - Optional path to the logo image
 * @returns {JSX.Element} The rendered header component
 */
const Header = (props: any) => {
  return (
    <div className='headerMain'>
      {/* Conditional rendering based on availability of headerLogo */}
      {(props?.title && (props.headerLogo === '' || props.headerLogo === null || props.headerLogo === undefined)) ?
        // Display text title when headerLogo is not available
        <div className='headerLogo'>
          <h4 className='headerTitle'>{props.title}</h4>
        </div>
        :
        // Display logo image when headerLogo is available
        <div className="dynamicHeader">
          <img className='dynamicHeaderLogo' alt='header icon' src={props.headerLogo} />
        </div>
      }
      <div className='authDividerHeader'></div>
      {/* Leader Portal text - always displayed regardless of logo/title choice */}
      <h4 className='headerTitle'>Leader Portal</h4>
    </div>
  );
};

export default Header;
